import { Collections } from '@uploadcam/common';
import { collection, Firestore, getCountFromServer, query, where } from 'firebase/firestore';

export class GetTeamSizeInteractor {
  constructor(private readonly db: Firestore) {}

  public async execute(id: string): Promise<number> {
    const total = await getCountFromServer(
      query(collection(this.db, Collections.Users), where('teamId', '==', id)),
    );
    return total.data().count;
  }
}
